var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TracksSearchResultTable } from "./ui/tracks-search-result-table";
import { usePage } from "./model/use-page";
import { Link } from "react-router-dom";
import { GenreEditDialog } from "./ui/genre-edit-dialog";
import { Search } from "./ui/search";
var Page = function () {
    var _a = usePage(), tracks = _a.tracks, pagination = _a.pagination, sorting = _a.sorting, search = _a.search;
    var _b = __read(useState(false), 2), isGenreEditDialogOpen = _b[0], setGenreEditDialogOpen = _b[1];
    var openGenreEditDialog = function () { return setGenreEditDialogOpen(true); };
    var closeGenreEditDialog = function () { return setGenreEditDialogOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(Button, { variant: "text", color: "primary", component: Link, to: "/admin/tracks/upload" }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u0440\u0435\u043A\u0438")),
        React.createElement(Box, { component: Paper, mt: 2, p: 2 },
            React.createElement(Typography, null,
                "\u041E\u0442\u043C\u0435\u0447\u0435\u043D\u043E: ",
                tracks.checked.count),
            React.createElement(Typography, null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u043C\u0438:"),
            React.createElement(Box, { display: "flex", mt: 1 },
                React.createElement(Button, { onClick: tracks.unCheckAll, disabled: tracks.checked.none, color: "primary", variant: "outlined" }, "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435"),
                React.createElement(Box, { ml: 1 },
                    React.createElement(Button, { onClick: tracks.publish, disabled: tracks.checked.none, color: "primary", variant: "outlined" }, "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C")),
                React.createElement(Box, { ml: 1 },
                    React.createElement(Button, { onClick: tracks.unpublish, disabled: tracks.checked.none, color: "primary", variant: "outlined" }, "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438")),
                React.createElement(Box, { ml: 1 },
                    React.createElement(Button, { onClick: openGenreEditDialog, disabled: tracks.checked.none, color: "primary", variant: "outlined" }, "\u041D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0436\u0430\u043D\u0440\u044B")),
                React.createElement(Box, { ml: "auto" },
                    React.createElement(Button, { onClick: tracks.removeChecked, disabled: tracks.checked.none, color: "secondary", variant: "outlined" }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))),
        React.createElement(GenreEditDialog, { checkedTracksIds: tracks.checked.ids, isOpen: isGenreEditDialogOpen, close: closeGenreEditDialog }),
        React.createElement(Search, { genres: search.genres, search: search }),
        React.createElement(Box, { component: Paper, mt: 2 },
            React.createElement(TracksSearchResultTable, { tracks: tracks, pagination: pagination, sorting: sorting }))));
};
export var TracksPage = function () {
    return (React.createElement(AdminLayout, null,
        React.createElement(Page, null)));
};
